<template>
  <div>
    <swiper
      :slidesPerView="4"
      :spaceBetween="12"
      :breakpoints="{
        320: {
          slidesPerView: 1,
          spaceBetween: 12,
        },
        768: {
          slidesPerView: 1,
          spaceBetween: 12,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 12,
        },
        1700: {
          slidesPerView: 4,
          spaceBetween: 12,
        },
      }"
      :centeredSlides="false"
      :modules="modules"
      class="mySwiper"
    >
      <swiper-slide
        v-for="(adv, index) in advertisings"
        :key="index"
        class="product product-7 text-center"
      >
        <div class="product product-7 text-center">
          <figure class="product-media">
            <a :href="adv['link'] ?? '#'">
              <img
                :src="adv['image']"
                alt="copertina post"
                class="product-image"
              />
            </a>
          </figure>
          <!-- End .product-media -->

          <div class="product-body">
            <div class="product-cat">
              <a :href="adv['link'] ?? '#'"> {{ adv["subtitle"] }}</a>
            </div>
            <!-- End .product-cat -->
            <h3 class="product-title">
              <a :href="adv['link'] ?? '#'">{{ adv["textbutton"] }}</a> <br />
            </h3>
            <p>{{ adv["description"] }}</p>
          </div>
          <!-- End .product-body -->
        </div>
        <!-- End .product -->
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";

import "swiper/css/pagination";
import { Pagination } from "swiper";
export default {
  name: "AdvComponent",
  props: ["advertisings"],
  components: {
    Swiper,
    SwiperSlide,
    //VideoComponent,
  },
  setup() {
    return {
      modules: [Pagination],
    };
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 6, // Numero di elementi da visualizzare nella stessa riga
        spaceBetween: 5, // Spazio tra gli elementi
      },
    };
  },
  mounted() {},
  created() {},
  methods: {},
};
</script>
